// @flow
import type { LocalizedFormatFunction, StrictStringMap } from '@rover/react-lib/types';
import { DEFAULT_LANG } from '@rover/shared/js/constants/i18n/language';

import I18N_FORMAT_MAP from '@rover/design-system/style-dictionary/build/es6/i18nFormatMap.constants';
import generateExternalFormatMap from './generateExternalFormatMap';

const generateFormatMap = (
  getLocalizedFormat: LocalizedFormatFunction,
  language: ?string
): StrictStringMap =>
  Object.keys(I18N_FORMAT_MAP[DEFAULT_LANG]).reduce((acc, key) => {
    acc[key] = getLocalizedFormat(key, language);
    return acc;
  }, generateExternalFormatMap(getLocalizedFormat, language));

export default generateFormatMap;



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/generateFormatMap.js